export const SITSTAT_WIDGET_IDS = [
  'notifications',
  'map-layers',
  'events',
  'actions',
  'aors',
  'incidents',
  'assets',
] as const;

export type SitStatWidgetId = (typeof SITSTAT_WIDGET_IDS)[number];

/** @deprecated Use SitStatWidgetId */
export type SitStatDefaultWidgetId = SitStatWidgetId;

export type SitStatRailColumnId = 'left' | 'right';
export type SitStatColumnId = SitStatRailColumnId | 'center';

export type SitStatLayout = Record<SitStatColumnId, SitStatWidgetId[]>;

/** Expanded rails take 20% of the SitStat workspace row. */
export const SITSTAT_RAIL_WIDTH_PERCENT = 20;
export const SITSTAT_COLLAPSED_RAIL_WIDTH_PX = 36;

export const SITSTAT_DEFAULT_LAYOUT: SitStatLayout = {
  left: ['notifications', 'events', 'incidents'],
  center: [],
  right: ['aors', 'map-layers', 'actions'],
};

export const SITSTAT_WIDGET_TITLES: Record<SitStatWidgetId, string> = {
  notifications: 'Notifications',
  'map-layers': 'Map Layers',
  events: 'Events',
  actions: 'Tasks',
  aors: 'AORs',
  incidents: 'Incidents',
  assets: 'Assets',
};

export function isSitStatWidgetId(value: string): value is SitStatWidgetId {
  return (SITSTAT_WIDGET_IDS as readonly string[]).includes(value);
}

export function isSitStatRailColumnId(
  value: string
): value is SitStatRailColumnId {
  return value === 'left' || value === 'right';
}
